import { render, staticRenderFns } from "./CreateOrderLocation.vue?vue&type=template&id=fd0bcd0a&scoped=true"
import script from "./CreateOrderLocation.vue?vue&type=script&lang=js"
export * from "./CreateOrderLocation.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderLocation.vue?vue&type=style&index=0&id=fd0bcd0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0bcd0a",
  null
  
)

export default component.exports